import Grid from "@mui/material/Unstable_Grid2/Grid2.js";
import { FastField, Field } from "formik";
import React from "react";
import DebouncedTextField from "../../../common/components/form/DebouncedTextField.jsx";
import FormSelect from "../../../common/components/form/FormSelect.jsx";
import ProductCategoryAutocomplete from "../../../common/components/form/ProductCategoryAutocomplete.jsx";

const BaseProductSearchCriteria = () => {
  return (
    <Grid container sx={{ mb: 1 }} spacing={2} direction="row">
      <Grid>
        <Field
          component={DebouncedTextField}
          label="Search..."
          name="searchText"
        />
      </Grid>
      <Grid xs="auto">
        <FastField
          component={FormSelect}
          name="activeStatus"
          label="Product Status"
          options={[
            { value: "", label: "All" },
            { value: "active", label: "Active" },
            { value: "inactive", label: "Inactive" },
          ]}
          sx={{ minWidth: "150px" }}
        />
      </Grid>
      <Grid xs="auto">
        <FastField
          component={ProductCategoryAutocomplete}
          name="category"
          label="Product Category"
          sx={{ width: 250 }}
        />
      </Grid>
    </Grid>
  );
};

export default BaseProductSearchCriteria;
